// extracted by mini-css-extract-plugin
export default {"component":"eXu_Q2HW","background-opacity":"Hx30HrF_","scrollOverlay":"c5PR07SD"};